var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ui-city-suggest" },
    [
      _c("ui-input", {
        ref: "query",
        attrs: {
          label: _vm.label,
          autocomplete: "off",
          placeholder: "Начните вводить город",
          required: _vm.required,
          clearable: ""
        },
        on: {
          input: _vm.getSuggestions,
          focus: _vm.getSuggestions,
          blur: _vm.autofill
        },
        model: {
          value: _vm.query,
          callback: function($$v) {
            _vm.query = $$v
          },
          expression: "query"
        }
      }),
      _c(
        "div",
        { staticClass: "ui-city-suggestions" },
        [
          _c(
            "ui-dropdown",
            { attrs: { visible: _vm.showSuggestions } },
            [
              _vm.suggestions.length
                ? _vm._l(_vm.suggestions, function(city) {
                    return _c(
                      "div",
                      {
                        key: city.id,
                        on: {
                          click: function($event) {
                            return _vm.select(city)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(city.name) + "\n        "
                        )
                      ]
                    )
                  })
                : [
                    _c("div", { staticClass: "not-found" }, [
                      _vm._v(
                        "\n          По вашему запросу ничего не найдено\n        "
                      )
                    ])
                  ]
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }